import { AttachmentEntityInterface, UserEntityInterface } from '@types';
import { answerEnvironmentActionTypes } from '@actions/actionTypes/answerEnvironment';
import { addContacts, cleanObject } from '@utils';
import { store } from '../store';
import { LangEnum } from '@enums';

export const setAnswerUser = (user: UserEntityInterface) => {
  return {
    type: answerEnvironmentActionTypes.SET_ANSWER_USER,
    payload: user,
  };
};

export const setAnswerQuestionnaireContext = (context: string) => {
  return {
    type: answerEnvironmentActionTypes.SET_ANSWER_QUESTIONNAIRE_CONTEXT,
    payload: typeof context === 'object' ? context : JSON.parse(context || '{}'),
  };
};

export const setAnswerContext = (context: string) => {
  const { questionnaireContext, owner } = store.getState().answerEnvironment;

  return {
    type: answerEnvironmentActionTypes.SET_ANSWER_CONTEXT,
    payload: addContacts(cleanObject(JSON.parse(context)), owner, {
      withoutPhone: !questionnaireContext.hasContacts,
      withoutSkype: !questionnaireContext.hasContacts,
    }),
  };
};

export const setAnswerAttachments = (attachments: AttachmentEntityInterface[]) => {
  return {
    type: answerEnvironmentActionTypes.SET_ANSWER_ATTACHMENTS,
    payload: attachments,
  };
};

export const setAnswerUserAbbr = (userAbbr: string) => {
  return {
    type: answerEnvironmentActionTypes.SET_ANSWER_USER_ABBR,
    payload: userAbbr,
  };
};

export const setAnswerEnvLanguage = (language: LangEnum) => {
  return {
    type: answerEnvironmentActionTypes.SET_ANSWER_LANGUAGE,
    payload: language,
  };
};
